import React, {useState, useEffect} from "react";
import DataTable from "react-data-table-component";
import { Modal } from "react-bootstrap";
import PageHeader from "../../components/common/PageHeader";
import QuotationServices from "../../services/QuotationServices";
import useQuotationSubmit from "../../hooks/useQuotationSubmit";
import { FaFileImage, FaFilePdf } from "react-icons/fa";
import dayjs from "dayjs";
import ModalLoading from "../../components/Loading/ModalLoading"; 
import useAsync from "../../hooks/useAsync";
import Uploader from "../../components/imageuploader/Uploader"; 
 
function Quotation() {   
    const [rowData, setrowData] = useState([]);
    const [columnT, setcolumnT] = useState([]);
    const [QuotationId, setQuotationId] = useState(""); 
    // const [clientData, setClientData] = useState([]); 
    // const [EmployeeData, setEmployeeData] = useState([]);   
    // const [loadings, setLoading] = useState(true); // loading state 
    const { data, loading } = useAsync(() => QuotationServices?.getAllQuotation());

    // console.log(" changed ");

    const {  
        setIsModal,  
        isConfirmModal, setIsConfirmModal, handleConfirmQuotation, 
        imageUrl, setImageUrl, downloadFile
      } = useQuotationSubmit(QuotationId); 
 
    // const changeStatus = (e) => {
    //     var statusval = e.target.checked === true ? "InActive": "Active";   
    //     setStatus(statusval);
    // }   
 
    useEffect(()=>{
        const getAllQuotation = async (data) => {
            const result = data;   
            setrowData(result?.data);
             
            // var rowData = result?.data;
            // console.log("rowdtaa", rowData); 
            var columnTs = "";
            columnTs = [ 
                { 
                    name: "S.No.",
                    selector: (_, index) => index + 1, 
                    sortable: true,
                    minWidth: "50px"
                }, 
                {
                    name: "CUSTOMER NAME", 
                    selector: (rowData) => rowData?.clientId?.clientName,
                    sortable: true,
                    cell: (rowData) => <div className="fw-bold ">{rowData?.clientId?.clientName}</div>,
                    minWidth: "180px"
                }, 
                {
                    name: "EMPLOYEE NAME",
                    selector: (rowData) => rowData?.employeeId?.employeeName,
                    sortable: true,
                    minWidth: "180px"
                },
                {
                    name: "PROJECT TYPE",
                    selector: (rowData) => rowData?.scheduleId?.projectName,
                    sortable: true,
                    minWidth: "180px"
                },
                {
                    name: "QUOTATION FILE", 
                     selector: (row) =>
                        <a href={row?.quotationFile} target="_blank" download={row?.quotationFile.split('/').pop()}>
                            {row?.quotationFile.split('/').pop().toLowerCase().endsWith(".pdf") ? <FaFilePdf size={25} color="#3762ed" /> : <FaFileImage size={25} color="#3762ed" />}
                        </a>,
                    sortable: true,
                    minWidth: "150px"  
                },  
                {  
                    name: "CONFIRMED FILE",    
                     selector: (row) =>
                        <a href={row?.confirmedReqFile} target="_blank" download={row?.confirmedReqFile.split('/').pop()}>
                            {row?.confirmedReqFile.split('/').pop().toLowerCase().endsWith(".pdf") ? <FaFilePdf size={25} color="#3762ed" /> : <FaFileImage size={25} color="#3762ed" />}
                        </a>,
                    sortable: true,  
                    minWidth: "150px" 
                },
                {
                    name: "CONFIRMED DATE",
                    selector: (rowData) => dayjs(rowData?.confirmedDate).format("DD-MM-YYYY"),
                    sortable: true,  
                    minWidth: "180px"
                }, 
                { 
                    name: "STATUS",
                    selector: (rowData) => rowData?.status,
                    sortable: true,
                    cell: row => <span className={`badge ${row.status === "Completed" ? 'bg-success' : "bg-warning"}`}>{row.status}</span>,
                    minWidth: "130px"
                },  
                {
                    name: "ACTION",
                    selector: (row) => { },  
                    sortable: true,
                    minWidth: "200px",
                    cell: (row) => <div className="btn-group" role="group" aria-label="Basic outlined example">
                        <button type="button" className="btn btn-info" onClick={() => { setIsConfirmModal(true); setQuotationId(row?._id); }} >Accept</button>
                        <button type="button" className="btn btn-danger" onClick={() => { setQuotationId(row?._id); handleConfirmQuotation(row?._id, "Reject") }}>Reject</button> 
                    </div> 
                }  
    
            ] 
            setcolumnT(columnTs); 
        } 
     
        // const getClientDropdownData = async () => {
        //     const result = await DropdownServices.getClientDropdown();
        //     setClientData(result); 
        //     // console.log(" getClientDropdown == ",result);
        // } 
    
        // const getEmpDropdownData = async () => {
        //     const result = await DropdownServices.getEmployeeDropdown(); 
        //     setEmployeeData(result); 
        // }

        setTimeout(() => { 
            getAllQuotation(data);  
        }, 100); 
        // getClientDropdownData();
        // getEmpDropdownData();
    }, [data]);

    return (
        <div className="container-xxl">
            <PageHeader headerTitle="Quotation" renderRight={() => {
                return <div className="col-auto d-flex w-sm-100">
                    <button className="btn btn-dark btn-set-task w-sm-100" onClick={() => { setIsModal(true); setQuotationId(""); }}><i className="icofont-plus-circle me-2 fs-6"></i>Add Quotation</button>
                </div>
            }} />
            <div className="row clearfix g-3">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <DataTable 
                                title="Schedule"  
                                columns={columnT}
                                data={rowData}
                                defaultSortField="title"
                                pagination 
                                selectableRows={false}
                                className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                highlightOnHover={true}
                                progressPending={loading}
                                progressComponent={<ModalLoading loading={loading} />}
                            />
                        </div>
                    </div>
                </div>
            </div>   

            {/* Schedule Confirm modal */}
            <Modal show={isConfirmModal} centered size="xs" backdrop={isConfirmModal} onHide={() => { setIsConfirmModal(false) }}>
            
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Confirm Quotation</Modal.Title>
                </Modal.Header>
                <Modal.Body className="justify-content-center flex-column d-flex">
                    <label htmlFor="confirmFile" className="form-label"> Status : <b>Accept Quotation</b></label>
                    <br/>  
                    <label htmlFor="confirmFile" className="form-label"> File Upload</label> 
                    <Uploader
                        imageUrl={imageUrl} 
                        setImageUrl={setImageUrl} 
                        folder="AcceptFile"  
                        name="image"      
                    />
                </Modal.Body> 
                <Modal.Footer> 
                    <button type="button" className="btn btn-danger color-fff" onClick={() => handleConfirmQuotation(QuotationId, "Accept")}>Submit</button>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsConfirmModal(false) }}>Cancel</button> 
                </Modal.Footer>
            </Modal>  
        </div>
    )

}

export default Quotation;    